import { useUser } from '@folklore/auth';
import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useCallback, useMemo, useState } from 'react';

import { useLabels } from '../../contexts/LabelsContext';
import CircleCheck from '../icons/CircleCheck';
import LockIcon from '../icons/Lock';
import SceneBonusModal from '../modals/SceneBonusModal';
import Button from './Button';

import styles from '../../../styles/buttons/tradition-bonus-button.module.scss';

import wheelIcon from '../../../img/iganoel2024/bonus_wheel.png';

const propTypes = {
    label: PropTypes.node,
    hiddenGames: PropTypes.arrayOf(PropTypes.shape({})),
    className: PropTypes.string,
};

const defaultProps = {
    label: null,
    hiddenGames: null,
    className: null,
};

function TraditionBonusButton({ label, hiddenGames, className }) {
    const [modalOpened, setModalOpened] = useState(false);
    const bonusGame = useMemo(
        () => hiddenGames.find(({ handle }) => handle === 'bonus'),
        [hiddenGames],
    );
    const { canParticipate = true } = bonusGame || {};
    const { gameBonusButtonCompleted } = useLabels();

    const route = useUrlGenerator();
    const { sceneNumber = null } = useUser();
    const onClickButton = useCallback(() => {
        setModalOpened(true);
    }, []);
    const onCloseModal = useCallback(() => {
        setModalOpened(false);
    }, []);

    return (
        <>
            <Button
                href={
                    sceneNumber !== null
                        ? route('game', {
                              game: 'bonus',
                          })
                        : null
                }
                onClick={sceneNumber === null ? onClickButton : null}
                className={classNames([styles.container, { [className]: className !== null }])}
            >
                <img src={wheelIcon} className={styles.icon} alt="Wheel" />
                <span
                    className={styles.label}
                    dangerouslySetInnerHTML={{
                        __html: !canParticipate ? gameBonusButtonCompleted : label,
                    }}
                />
                {!canParticipate ? (
                    <CircleCheck locked={sceneNumber === null} className={styles.check} />
                ) : (
                    <LockIcon locked={sceneNumber === null} className={styles.lock} />
                )}
            </Button>
            {modalOpened ? <SceneBonusModal onClose={onCloseModal} /> : null}
        </>
    );
}

TraditionBonusButton.propTypes = propTypes;
TraditionBonusButton.defaultProps = defaultProps;

export default TraditionBonusButton;
